import React, { forwardRef } from 'react';
import { MenuItem as MenuItemNew } from './MenuItem';
import { MenuGroupIdContext } from './context';
import { convertOldMenuItemProps } from './converter.old';
import type { OldMenuItemProps } from './converter.old';

export type MenuItemProps = OldMenuItemProps;

export const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>(({ groupId, ...props }, ref) => {
  const menuItem = <MenuItemNew {...convertOldMenuItemProps(props)} ref={ref} />;

  return groupId !== undefined ? (
    <MenuGroupIdContext.Provider value={groupId}>{menuItem}</MenuGroupIdContext.Provider>
  ) : (
    menuItem
  );
});
